var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { position: "relative", height: "100%", padding: "15px" },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            "modal-append-to-body": "",
            top: _vm.dialogTopMargin,
            title: "【" + _vm.currentTravelName + "】旅客使用紀錄",
            visible: _vm.travelersDetailsDialogNoteVisible,
            width: "55%",
          },
          on: {
            closed: function ($event) {
              _vm.currentTravelID = null
            },
            "update:visible": function ($event) {
              _vm.travelersDetailsDialogNoteVisible = $event
            },
          },
        },
        [
          _c("TravelersUsed", {
            attrs: {
              travelID: _vm.currentTravelID,
              travelName: _vm.currentTravelName,
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-tooltip",
                { attrs: { content: "匯 出 Excel" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: {
                        type: "primary",
                        loading: _vm.exportExcelLoading,
                      },
                      on: { click: _vm.exportExcel },
                    },
                    [_vm._v("匯出資料")]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.travelersDetailsDialogNoteVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.fileTypeDesc == "payment" ? "請款單" : "發票",
            visible: _vm.dialogFileVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFileVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            _vm._l(
              _vm.fileTypeDesc == "payment" ? _vm.files1 : _vm.files2,
              function (o) {
                return _c("div", { key: o.url, staticClass: "text item" }, [
                  _c("a", { staticClass: "link", attrs: { href: o.url } }, [
                    _vm._v(_vm._s(o.fileName)),
                  ]),
                ])
              }
            ),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogFileVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 12 } },
        [
          _c("el-col", { attrs: { span: 24, sm: 24, lg: 8, xl: 11 } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  gap: "0 8px",
                  "align-items": "flex-start",
                  "padding-bottom": "8px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      gap: "6px 0",
                      "flex-grow": "2",
                    },
                  },
                  [
                    _vm.dateRangeInfo
                      ? _c("el-tag", [
                          _vm._v("計算區間：" + _vm._s(_vm.dateRangeInfo)),
                        ])
                      : _vm._e(),
                    _vm.headCountTitle
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v(_vm._s(_vm.headCountTitle)),
                        ])
                      : _vm._e(),
                    _vm.balanceTitle
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v(_vm._s(_vm.balanceTitle)),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      gap: "6px 0",
                      "flex-grow": "1",
                    },
                  },
                  [
                    _c(
                      "el-tag",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-weight": "bolder",
                        },
                        attrs: { type: "danger" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c("span", [_vm._v(" 總金額： ")]),
                            _vm._v(" " + _vm._s(_vm.sumPrice) + " "),
                          ]
                        ),
                      ]
                    ),
                    !!_vm.headCountTitle
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              "font-weight": "bolder",
                            },
                            attrs: { type: "danger" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c("span", [_vm._v(" 可用人數： ")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.headCount.toLocaleString()) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    !!_vm.balanceTitle
                      ? _c(
                          "el-tag",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              "font-weight": "bolder",
                            },
                            attrs: { type: "danger" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c("span", [_vm._v(" 餘額折抵： ")]),
                                _vm._v(
                                  " $" +
                                    _vm._s(_vm.balance.toLocaleString()) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24, sm: 24, lg: 16, xl: 13 } },
            [
              _c(
                "el-form",
                { staticClass: "filter-form", attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "查詢年月" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            placeholder: "請選擇",
                            "value-key": "id",
                          },
                          on: { change: _vm.getList },
                          model: {
                            value: _vm.listQuery.dates,
                            callback: function ($$v) {
                              _vm.$set(_vm.listQuery, "dates", $$v)
                            },
                            expression: "listQuery.dates",
                          },
                        },
                        _vm._l(_vm.dates, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label:
                                item.year +
                                "-" +
                                (item.month < 10
                                  ? "0" + item.month
                                  : "" + item.month),
                              value: item,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "查詢" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "輸入團號或團名稱" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.getList($event)
                          },
                        },
                        model: {
                          value: _vm.listQuery.qry,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "qry", $$v)
                          },
                          expression: "listQuery.qry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-button", {
                    staticStyle: { "margin-top": "8px", "margin-left": "5px" },
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      circle: "",
                      disabled: _vm.listLoading,
                    },
                    on: { click: _vm.getList },
                  }),
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      type: "success",
                      loading: _vm.listLoading,
                      circle: "",
                      icon: "el-icon-refresh-left",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", icon: "el-icon-download" },
                      on: {
                        click: function ($event) {
                          return _vm.download("payment")
                        },
                      },
                    },
                    [_vm._v("請款單下載")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "medium",
                        type: "danger",
                        icon: "el-icon-download",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.download("invoice")
                        },
                      },
                    },
                    [_vm._v("發票下載")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-alert",
        {
          staticStyle: {
            "background-color": "#ffd643",
            color: "#4b4b4b",
            "margin-bottom": "10px",
          },
          attrs: { closable: false, type: "info", effect: "dark" },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " 計算區間：ex.2022-09-26-2022-10-25，以行程結束日於此區間內做為呈現"
            ),
            _c("br"),
          ]),
        ],
        2
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "70%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "totalTable",
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "show-summary": "",
                "summary-method": _vm.getSummaries,
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "App+網卡總金額(含稅)",
                  width: "150",
                  prop: "totalPriceTaxStr",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "tax-price" }, [
                          _vm._v(_vm._s(scope.row.pricing.totalPriceTaxStr)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡項目", width: "150" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.networkCardSouece
                          ? [
                              _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.networkCardSouece.cardName)
                                ),
                              ]),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡金額", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.networkCardSouece
                          ? [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "17px" } },
                                [
                                  _vm._v(
                                    "$" +
                                      _vm._s(scope.row.networkCardSouece.price)
                                  ),
                                ]
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡數量", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.networkCardSouece
                          ? [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "17px" } },
                                [_vm._v(_vm._s(scope.row.networkCardCount))]
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡運費", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.networkCardSouece
                          ? [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "17px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.pricing
                                        .networkCardPostFeePriceTaxStr
                                    )
                                  ),
                                ]
                              ),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "網卡使用總金額(含稅)",
                  width: "150",
                  prop: "networkCardUseTotalPriceTaxStr",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "tax-price" }, [
                          _vm._v(
                            _vm._s(
                              scope.row.pricing.networkCardUseTotalPriceTaxStr
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "App使用總金額(含稅)",
                  width: "150",
                  prop: "appUseTotalPriceTaxStr",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "tax-price" }, [
                          _vm._v(
                            _vm._s(scope.row.pricing.appUseTotalPriceTaxStr)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "團號", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.tourGroupNo))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "團名", width: "350" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [_vm._v(_vm._s(row.travelName))]),
                        _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              { staticStyle: { "font-size": "14px" } },
                              [
                                _vm._v(" 出發 "),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(row.beginDate + " " + row.beginTime)
                                  ),
                                ]),
                                _vm._v(" - 回程 "),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(row.endDate + " " + row.endTime)
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "天數",
                  width: "80",
                  prop: "totalday",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.totalday))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "旅客數",
                  width: "80",
                  prop: "tourist",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.tourist))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "使用旅客名單", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "info", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.getTravelersDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }